import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'email-templates/list',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./ListEmailTemplate').default
      callback(null, component)
    }, 'ListEmailTemplate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/ListEmailTemplate/index.js